import * as React from "react";
import {MouseEvent} from "react";
import User from "../../_data/models/User";
import MyProfileTabViewComponent from "./MyProfileTabViewComponent";
import MyProfileTabsComponent from "./MyProfileTabsComponent";
import Meta from "../../_data/models/Meta";

interface result {
    items: any;
    meta: Meta;
}

interface resultWithLoad extends result {
    loading: boolean;
}

interface Props {
    profile: User;
    loadingTab: boolean;
    styles: result;
    specials: resultWithLoad;
    loadStyles: (id: number, e: MouseEvent<HTMLElement>) => void;
    loadLikedStyles: (id: number, e: MouseEvent<HTMLElement>) => void;
    loadSpecials: (id: number, e: MouseEvent<HTMLElement>) => void;
    viewFollowing: (id: number, name: string) => void;
    viewFollowers: (id: number, name: string) => void;
    showFollowing: boolean;
    styleLoad: boolean;
    likedStyleLoad: boolean;
    loadMore: (meta: Meta, resource: string, isLiked: boolean) => void;
}


const MyProfileBotttomComponent = (props: Props) => {
    return (
        <div>
            <MyProfileTabsComponent {...props}/>
            <MyProfileTabViewComponent {...props}/>
        </div>
    );
};

export default MyProfileBotttomComponent;


// WEBPACK FOOTER //
// ./app/client/user/components/MyProfileBottomComponent.tsx